import Toast from "./Toast";
 
const obj = {};
 
obj.install = function(Vue) {
  console.log("======");
 
  //1 创建组件构造器
  const toastContrutor = Vue.extend(Toast);
 
  //2 new的方式，根据组件构造器，可以创建一个组件对象
  const toast = new toastContrutor();
 
  //3 将组件对象，手动挂载到某一个元素上
  toast.$mount(document.createElement("div"));
 
  //4 toast.$el对应的就是上面挂载的div
  document.body.appendChild(toast.$el);
  
  //5装入vue原型
  Vue.prototype.$toast = toast;
  global.$toast = toast
};
 
export default obj;